import {
  getBranchIdCookie,
  getCurrencyIdCookie,
  getLangCookie,
} from "@/utils/functions/cookieOperations";
import { Keys } from "./keysValues";
export const getKey = (
  key: Keys,
  withoutBranchId?: boolean,
  lang?: "ar" | "en",
) => [
  key, 
  lang ?? getLangCookie(), 
  withoutBranchId ? "" : getBranchIdCookie(),
  getCurrencyIdCookie() ?? "",
];

export const getCompanyKey = (lang?: string) => [
  Keys.company,
  lang ?? getLangCookie() ?? "",
];
